import {Center, Paper, Space, Text} from "@mantine/core";
import {IconCircleCheck} from "@tabler/icons-react";
import React from "react";

export const ConfirmedMsgComponent =()=>{
    return <>
        <Center>
            <IconCircleCheck
                size={120}
                strokeWidth={0.5}
                color={'#40bf51'}
            />
        </Center>
        <Space h="xl"/>
        <Space h="xl"/>
        <Space h="xl"/>
        <Paper shadow="lg" radius="md" p="lg">
            <Center>
                <Text c={"green"}>
                    Talebiniz Onaylandı. Siteye Yönlendiriliyorsunuz...
                </Text>
            </Center>
        </Paper>
    </>
}